import { getMusicList } from '@/request/api/home';
import { onMounted, reactive } from 'vue';
export default {
  // vue2写法
  // data() {
  //     return {
  //         musicList: [

  //         ]
  //     }
  // },
  // methods: {
  //     async getGeDan() {
  //         let res = await getMusicList()
  //         this.musicList = res.data.result
  //         console.log(this.musicList);
  //     },
  //     getPlayCount(num) {
  //         if ( num>= 100000000) {
  //             return (num / 100000000).toFixed(1)+"亿"
  //         } else if (num >= 10000) {
  //             return (num/10000).toFixed(1)+"万"
  //         }
  //     }
  // },
  // mounted() {
  //     this.getGeDan()
  // }
  // vue3写法
  setup() {
    const state = reactive({
      musicList: []
    });
    onMounted(async () => {
      let res = await getMusicList();
      state.musicList = res.data.result;
      // console.log(state.musicList);
    });

    function getPlayCount(num) {
      if (num >= 100000000) {
        return (num / 100000000).toFixed(1) + "亿";
      } else if (num >= 10000) {
        return (num / 10000).toFixed(1) + "万";
      }
    }
    return {
      state,
      getPlayCount
    };
  }
};